/* global globalThis */
import axios from "axios";
import { showToastError } from "./toast";
import * as secureStorage from "../utils/secureStorage";

/**
 * Generic API caller using Axios
 *
 * @param {string} url - The API endpoint URL
 * @param {string} method - HTTP method (GET, POST, PUT, DELETE, etc.)
 * @param {object} body - Request body (for POST, PUT, etc.)
 * @param {object} headers - Optional headers
 * @param {object} params - Optional query parameters
 * @returns {Promise<any>} - The API response data
 */
const apiCaller = async (
  url,
  method = "GET",
  body = null,
  headers = {},
  params = {}
) => {
  const token = secureStorage.getToken();

  const publicUrls = ["/dropdown", "/farmer-landing"];
  const isPublic = publicUrls.some((p) => url.startsWith(p)) || headers?.noAuth;

  if (!token && !isPublic) {
    console.warn("[API] No token found — user not authenticated");
    return;
  }

  if (token) {
    headers.token = token;
  }
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const mainUrl = baseUrl + url;

  try {
    const config = {
      url: mainUrl,
      method,
      headers,
      data: body,
      params,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    const status = error.response?.status;
    const responseData = error.response?.data;

    if (status === 401 || responseData?.statusCode === 401) {
      const msg = (responseData?.message || "").toLowerCase();

      // OTP errors are business errors — NOT a session expiry.
      const isOtpError = msg.includes("otp");
      if (isOtpError) {
        throw responseData || error;
      }

      // Real session expiry — clear auth and redirect to login
      secureStorage.clearAuth();
      localStorage.clear();
      showToastError("Session expired. Please login again.");
      globalThis.location.href = "/";
      return;
    }

    throw responseData || error;
  }
};

export default apiCaller;
